import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { scroller } from 'react-scroll';
import { useIsMobile } from '../../../../shared/theme';
import { SectionDetails } from '../../../shared/sectionable/styles';
import EnquiryContext from '../../../shared/enquiry/context';
import Managers from './managers';
import WithUs from './with-us';
import GetInTouch from './get-in-touch';
import Enquiry from './enquiry';
import Summary from './summary';
import { scrollIfHashMatch } from '../../../shared/navigation/utils';
import { recordStatisticsEvent } from '../../../../services/statistics-service';
import useFundStateStore from '../../common/fund-state-hook';

const Container = styled(SectionDetails)`
  color: ${props => props.theme.bodyColor};
  ${props => !props.theme.isXLarge && `
    width: 100%;
  `};
`;

const sectionName = 'contact';
export default function Details({ fund, investorTypes }) {
  const { state: { showEnquiryForm, contactSent } } = React.useContext(EnquiryContext);
  const { activePartnership, company: { summary } } = fund;
  const showEnquiry = showEnquiryForm || contactSent;
  const { dispatch } = React.useContext(EnquiryContext);
  const set = useFundStateStore(state => state.set);
  const isMobile = useIsMobile();

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
  }, {});

  const hideInvestModal = () => {
    set(state => {
      state.showInvestModal = false;
    });
  };

  const scrollToContactForm = () => {
    scroller.scrollTo('contact', {
      // An offset is required to make the top of the form appear.
      offset: isMobile ? 20 : -100,
      duration: 1500,
      smooth: 'easeInOutQuint',
    });
  };

  function showContact(e, calledFromModal) {
    e && e.preventDefault();

    recordStatisticsEvent({
      event: calledFromModal ? 'fund_invest_modal_contact_clicked' : 'fund_profile_get_in_touch_section_contact_clicked',
      statisticable: 'fund',
      id: fund.id,
      page: calledFromModal ? `${window.location.pathname}#invest-modal` : window.location.pathname,
    });

    if (_.get(window, 'Livewire.currentUser.id')) {
      dispatch({ type: 'showEnquiryForm' });
    } else {
      window.location = '/sign_up?return_to_section=enquiry';
    }

    scrollToContactForm();
  }

  const contact = e => {
    e && e.preventDefault();
    hideInvestModal();
    showContact(e, true);
    scrollToContactForm();
  };

  return (
    <Container>
      {!!summary && <Summary summary={summary} />}
      <Managers {...fund} />
      <WithUs fund={fund} contact={contact} />
      {activePartnership && (
        <div name="contact">
          {showEnquiry
            ? <Enquiry fund={fund} investorTypes={investorTypes} />
            : <GetInTouch showContact={e => showContact(e, false)} />}
        </div>
      )}
    </Container>
  );
}

Details.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    activePartnership: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
    company: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      summary: PropTypes.string,
    }).isRequired,
    investUrl: PropTypes.string,
    fundPageUrl: PropTypes.string,
    members: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
    })).isRequired,
    pdsFileUrl: PropTypes.string.isRequired,
  }).isRequired,
  investorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
};
